import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div style={{ textAlign: 'center', padding: '4rem' }}>
    <h1>404 - Pagina non trovata</h1>
    <p>Ci dispiace, la pagina che stai cercando non esiste.</p>
    <Link to="/">Torna alla homepage</Link>
  </div>
);

export default NotFoundPage;
